import React from 'react';
import SettingsPanel from '../../shared-components/settings-panel/SettingsPanel';
import CwPlayer from '../../shared-components/cw-player/CwPlayer';
import {useSelector, useDispatch} from 'react-redux';
import { setTextToSend } from '../../shared-components/settings-panel/store/settingsSlice';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';

function HomePage(props){


    return (<CwPlayer />);
}

export default HomePage;